import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginDataService } from '../services/dhukan/login-data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {


  userBO:any={};

  userView:any={};

  constructor(public router: Router,public loginService: LoginDataService) {
    this.fnServiceChanges();
   }

  fnServiceChanges(){    
    
    this.loginService.serviceloginChange.subscribe((value) => {
        this.userView = value                 
        if(this.userView.userBO){                
          this.userBO= this.userView.userBO                
        }      
        
    }); 
  }

  ngOnInit() {
    if(sessionStorage.adtoken === undefined){
    //  this.router.navigate(['/Login']);
    }
    else{
      this.loginService.fnGetUserRoleList();
    }

   
  }


  fnLogout(){
    sessionStorage.removeItem("adtoken");
    this.router.navigate(['/Login']);
  }

}
